import React from 'react';
import moment from 'moment';

interface SpaceTaskCardProps {
    title: string;
    description: string;
    createdAt: string;
    assignedTo: {
        id: string;
        name: string;
        avatar?: string;
    };
    className?: string;
}

const SpaceTaskCard = ({ 
    title, 
    description, 
    createdAt, 
    assignedTo, 
    className = "" 
}: SpaceTaskCardProps) => {
    const formatTime = (dateString: string) => {
        return moment(dateString).format('h:mmA');
    };

    const getInitials = (name: string) => {
        return name
            .split(' ')
            .map(word => word.charAt(0).toUpperCase())
            .slice(0, 2)
            .join('');
    };

    return (
        <div className={`max-w-2xl w-full ${className}`}>
            {/* Success indicator */}
            <div className="flex items-center gap-2 mb-3">
                <div className="w-4 h-4 rounded-full bg-green-500 flex items-center justify-center">
                    <i className="ri-check-line text-white text-xs"></i>
                </div>
                <span className="text-sm font-medium text-gray-800">
                    Task created: {title}
                </span>
            </div>

            {/* Task details card */}
            <div className="bg-[#F9F5E7] border border-[#E8DDB5] rounded-lg p-4 shadow-none">
                <div className="mb-3">
                    <h4 className="font-medium text-gray-900 text-sm mb-1">
                        {title} <span className="text-gray-500 text-xs">{formatTime(createdAt)}</span>
                    </h4>
                    <p className="text-xs text-gray-600">
                        {description}
                    </p>
                </div>

                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <span className="text-xs text-gray-500">Assigned To</span>
                        {assignedTo.avatar ? (
                            <img 
                                src={assignedTo.avatar} 
                                alt={assignedTo.name}
                                className="w-5 h-5 rounded-full"
                            />
                        ) : (
                            <div className="w-5 h-5 rounded-full bg-gray-400 flex items-center justify-center">
                                <span className="text-white text-[10px] font-medium">
                                    {getInitials(assignedTo.name)}
                                </span>
                            </div>
                        )}
                        <span className="text-xs text-gray-700 font-medium">
                            {assignedTo.name}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SpaceTaskCard;
